export const primeReactProvider = {
  autoZIndex: false,
  zIndex: {
    modal: 100,
    overlay: 200,
    tooltip: 10000,
  },
};
